import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BaseRule from '../BaseRule.vue';
import { computed } from 'vue';
export default {
  __name: 'GeneralCompany',
  props: ['index', 'item', 'data'],
  setup(__props) {
    const props = __props;
    const data = computed(() => props.data);
    const index = computed(() => props.index);
    const item = computed(() => props.item);
    const word = {
      name: 'GeneralCompany'
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createBlock(BaseRule, {
        word: word,
        index: _unref(index),
        data: _unref(data)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          type: "textarea",
          rows: 2,
          modelValue: _unref(item).value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(item).value = $event),
          class: "input"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["index", "data"]);
    };
  }
};